import $ from 'jquery';
import 'what-input';
import Vue from 'vue';
import { instance } from './api/instance.js';
// import ExampleComponent from './components/ExampleComponent.vue';
// import PostsComponent from './components/PostsComponent.vue';
import BurgerMenu from './components/BurgerMenu.vue';
import Parallax from './components/Parallax';
import FadeIn from './components/FadeIn';
// import PostsComponent from './components/PostsComponent.vue';
// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
//window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
//$(document).foundation(); // foundation functions
// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: '#app',
  mounted() {
    console.log('Running Vue.js');
  },
  components: {
    'burger-menu': BurgerMenu,
    'parallax' : Parallax,
    'fade-in': FadeIn
  },
  data: {
  	menu_active: false,
    name: 'Test'
  },
  methods: {
  	toggle_menu: function() {
  		this.menu_active = !this.menu_active;
  	}
  }
});


(function($) {
    $(document).ready(function() { // Loaded when DOM is ready
        console.log("Running jQuery"); 

        //sticky menu
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
          const currentScroll = window.pageYOffset;
          if (currentScroll <= 0) {
            body.classList.remove(scrollUp);
            return;
          }
          
          if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
          } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
          }
          lastScroll = currentScroll;
          
        });

  });

  
  
})( jQuery );


